import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
const routes = [
    {
        path: '/pageList',
        name: 'pageList',
        component: function () {
            return import('../views/pageList.vue')
        }
    },
    {
        path: '/',
        name: 'home',
        component: function () {
            return import('../views/home.vue')
        },
        meta: {
            title: '首页 - 中国科技云门户'
        }
    },
    {
        path: '/square',
        name: 'square',
        component: function () {
            return import('../views/square.vue')
        },
        meta: {
            title: '模型广场 - 中国科技云门户'
        }
    },
    {
        path: '/detail',
        name: 'detail',
        component: function () {
            return import('../views/detail.vue')
        }
    },
    {
        path: '/service',
        name: 'service',
        component: function () {
            return import('../views/service.vue')
        },
        meta: {
            title: '软件与服务 - 中国科技云门户'
        }
    },
    {
        path: '/dataInterface',
        name: 'dataInterface',
        component: function () {
            return import('../views/dataInterface.vue')
        }
    },
    {
        path: '/50detail',
        name: '50detail',
        component: function () {
            return import('../views/50detail.vue')
        }
    },
    {
        path: '/serviceDetail',
        name: 'serviceDetail',
        component: function () {
            return import('../views/serviceDetail.vue')
        },
        meta: {
            title: '软件与服务详情 - 中国科技云门户'
        }
    },
    {
        path: '/dataSet',
        name: 'dataSet',
        component: function () {
            return import('../views/dataSet.vue')
        },
        meta: {
            title: '数据集 - 中国科技云门户'
        }
    },
    {
        path: '/detail2',
        name: 'detail2',
        component: function () {
            return import('../views/detail2.vue')
        }
    },
    {
        path: '/news',
        name: 'news',
        component: function () {
            return import('../views/news.vue')
        },
        meta: {
            title: '动态与通知 - 中国科技云门户'
        }
    },
    {
        path: '/article',
        name: 'article',
        component: function () {
            return import('../views/article.vue')
        },
        meta: {
            title: '动态与通知 - 中国科技云门户'
        }
    },
    {
        path: '/about',
        name: 'about',
        component: function () {
            return import('../views/articleAbout.vue')
        },
        meta: {
            title: '关于我们 - 中国科技云门户'
        }
    },
    {
        path: '/rule',
        name: 'rule',
        component: function () {
            return import('../views/articleRule.vue')
        },
        meta: {
            title: '管理与规范 - 中国科技云门户'
        }
    },
    {
        path: '/case',
        name: 'case',
        component: function () {
            return import('../views/case.vue')
        },
        meta: {
            title: '项目与案例 - 中国科技云门户'
        }
    },{
        path: '/articleCase',
        name: 'articleCase',
        component: function () {
            return import('../views/articleCase.vue')
        },
        meta: {
            title: '动态与通知 - 中国科技云门户'
        }
    }
]
const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { top: 0, y: 0 }
    }
})

router.afterEach(to => {
    const rawTitle = typeof to.meta.title === 'function' ? to.meta.title() : to.meta.title
    document.title = rawTitle || '中国科技云门户'
})

export default router